import EmberObject from '@ember/object';
import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';

import { Theme } from 'mewe/constants';

export default Route.extend({
  analytics: service('analytics'),

  theme: Theme.MYCLOUD,

  queryParams: {
    group: {
      refreshModel: true,
    },
    tag: {
      refreshModel: true,
    },
    filter: {
      refreshModel: true,
    },
  },

  model() {
    let model = EmberObject.extend({
      app: this.modelFor('app'),
      hash: this.hash,
    }).create();

    return model;
  },

  actions: {
    willTransition() {
      if (this.controller.get('tag')) {
        this.controller.set('tag', null);
        history.replaceState('', document.title, window.location.pathname); // prevent loading feed for tag on back navigation
      }
    },

    didTransition() {
      this.cleanRouteHash();
      this.analytics.sendEvent('pageViewed', '/mycloud');
      return true;
    },
  },
});
